import React, { ReactNode } from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { OverridableStyles } from '~/utils/types.ts';
import { Color } from '~/theme/index.ts';

export interface TypographyProps extends OverridableStyles {
  variant?:
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2';
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  color?: 'text.primary' | 'text.secondary' | 'text.white' | Color;
  noWrap?: boolean;
  paragraph?: boolean;
  children?: ReactNode;
}

const Typography: React.FC<TypographyProps> = ({
  variant,
  align,
  styleOverrides,
  paragraph,
  noWrap,
  children,
  color,
}) => {
  return (
    <MuiTypography
      variant={variant}
      align={align}
      noWrap={noWrap}
      paragraph={paragraph}
      sx={styleOverrides}
      color={color}
    >
      {children}
    </MuiTypography>
  );
};

export default Typography;
